import {
    ColDef,
    GetRowIdParams,
    ValueFormatterParams,
} from 'ag-grid-community';

import { ChartTemplateTableItemT } from './types';
import { formatDate } from 'helpers/formatHelper';

const TRANSLATION_PREFIX = 'support.chartsTemplates.gridSummary';

export const getRowId = (params: GetRowIdParams) => params.data.key;

export const getColDefs = (t: TranslationT): ColDef[] => [
    {
        field: 'title',
        headerName: t(`${TRANSLATION_PREFIX}.title`),
        flex: 3,
    },
    {
        field: 'authorizedFunctions',
        headerName: t(`${TRANSLATION_PREFIX}.authorizedFunctions`),
        flex: 2,
        // Will be changed in incoming PRs
        valueFormatter: (params: ValueFormatterParams) =>
            params.value?.join(', '),
    },
    {
        field: 'authorizedSoftwares',
        headerName: t(`${TRANSLATION_PREFIX}.authorizedSoftwares`),
        flex: 2,
        // Will be changed in incoming PRs
        valueFormatter: (params: ValueFormatterParams) =>
            params.value?.join(', '),
    },
    {
        field: 'status',
        headerName: t(`${TRANSLATION_PREFIX}.status.title`),
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
            t(`support.chartsTemplates.gridSummary.status.${params.value}`),
    },
    {
        field: 'createdAt',
        headerName: t(`${TRANSLATION_PREFIX}.createdAt`),
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
            formatDate(new Date(params.value)),
    },
    {
        field: 'actions',
        headerName: t('common.actions'),
        flex: 1,
        cellRenderer: 'actionsCellRenderer',
        valueGetter: ({ data }: { data: ChartTemplateTableItemT }) => data,
        sortable: false,
    },
];
